var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowArcLeft = function SvgIconArrowArcLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.635 7.884a1 1 0 1 0-2 0v6a.997.997 0 0 0 1 1h6a1 1 0 1 0 0-2H5.049l1.293-1.293A8.001 8.001 0 0 1 20 17.25a1 1 0 0 0 2 0 10 10 0 0 0-17.072-7.073L3.635 11.47z"
  })));
};
export default SvgIconArrowArcLeft;